import orderBy from 'lodash.orderby';

import {
  aboveBelowRangeTypeValues,
  type AdvanceFilter,
  beforeAfterBetweenTypeValues,
  containsTypeValues,
  defaultFilterValues,
  haveDoesntHaveTypeValue,
  matchNotMatchTypeValues,
} from '@/_containers';
import { invoiceEmailDeliveryStatusOptions } from '@/_pages/invoices/shared/schemas/invoice-email-status-options';
import { executionStatusOptions, invoiceLifecycleStatusOptions } from '@/_pages/invoices/shared/schemas/status-options';

import { fieldNames } from '../../shared';
import type { InvoiceFilterSchema } from '../../shared/filters';

export const advFilters: AdvanceFilter<InvoiceFilterSchema>[] = orderBy(
  [
    {
      ...defaultFilterValues,
      mainKey: 'invoice_number',
      title: fieldNames.invoice_number.name,
      fieldType: 'string',
      types: [...containsTypeValues],
    },
    {
      ...defaultFilterValues,
      mainKey: 'invoice_date',
      title: fieldNames.invoice_date.name,
      fieldType: 'date',
      types: [...beforeAfterBetweenTypeValues],
    },
    {
      ...defaultFilterValues,
      mainKey: 'due_date',
      title: 'Due Date',
      fieldType: 'date',
      types: [
        {
          ...matchNotMatchTypeValues[0],
          name: 'On',
        },
        ...beforeAfterBetweenTypeValues,
      ],
    },
    {
      ...defaultFilterValues,
      mainKey: 'account_receivables',
      subKey: 'balance_due',
      title: 'Balance Due',
      fieldType: 'number',
      types: [...aboveBelowRangeTypeValues],
    },
    {
      ...defaultFilterValues,
      mainKey: 'status',
      title: fieldNames.status.name,
      fieldType: 'select',
      options: invoiceLifecycleStatusOptions,
      types: [...matchNotMatchTypeValues],
    },
    {
      ...defaultFilterValues,
      mainKey: 'execution_status',
      title: fieldNames.execution_status.name,
      fieldType: 'select',
      options: executionStatusOptions,
      types: [...matchNotMatchTypeValues],
    },
    {
      ...defaultFilterValues,
      mainKey: 'latest_email_history',
      subKey: 'delivery_status',
      title: 'Email Delivery Status',
      fieldType: 'select',
      options: invoiceEmailDeliveryStatusOptions,
      types: [...matchNotMatchTypeValues],
    },
    {
      ...defaultFilterValues,
      mainKey: 'latest_email_history',
      title: 'Email Warning',
      fieldType: 'radio',
      types: [
        {
          name: 'Cannot email (no billing contact)',
          value: 'doesnt_have',
          absoluteKey: 'agreement_links.agreement.billing_contact',
          labelValue: 'Cannot email (no billing contact)',
        },
        {
          name: 'Failed delivery',
          value: 'match',
          absoluteKey: 'latest_email_history.delivery_status',
          optionValue: 'failed',
          labelValue: 'Failed delivery',
        },
      ],
    },
    {
      ...defaultFilterValues,
      mainKey: 'brand',
      subKey: 'name',
      title: fieldNames['brand'].name,
      fieldType: 'custom',
      types: [
        ...containsTypeValues,
        { ...haveDoesntHaveTypeValue[0], absoluteKey: 'brand', labelValue: 'Known ' + fieldNames['brand'].name },
        { ...haveDoesntHaveTypeValue[1], absoluteKey: 'brand', labelValue: 'Unknown ' + fieldNames['brand'].name },
      ],
    },
    {
      ...defaultFilterValues,
      mainKey: 'partner',
      subKey: 'name',
      title: fieldNames['partner'].name,
      fieldType: 'custom',
      types: [
        ...containsTypeValues,
        { ...haveDoesntHaveTypeValue[0], absoluteKey: 'partner', labelValue: 'Known ' + fieldNames['partner'].name },
        {
          ...haveDoesntHaveTypeValue[1],
          absoluteKey: 'partner',
          labelValue: 'Unknown ' + fieldNames['partner'].name,
        },
      ],
    },

    {
      ...defaultFilterValues,
      mainKey: 'client',
      subKey: 'name',
      title: fieldNames['client'].name,
      fieldType: 'custom',
      types: [
        ...containsTypeValues,
        { ...haveDoesntHaveTypeValue[0], absoluteKey: 'client', labelValue: 'Known ' + fieldNames['client'].name },
        { ...haveDoesntHaveTypeValue[1], absoluteKey: 'client', labelValue: 'Unknown ' + fieldNames['client'].name },
      ],
    },
  ],
  'title'
);
